<template>
  <div class="row">
    <div class="col-lg-10">
      <div class="widget">
        <div class="widget-heading -list">
          <h1 class="textStyle">
            {{
              $tc("global.list.title", 1, {
                name: $tc("registration.alert.title", 2).toLowerCase(),
              })
            }}
            {{
              isFiltered
                ? "(" +
                  (maxResult ? maxResult : Object.keys(datas).length) +
                  " résultat" +
                  ((maxResult ? maxResult : Object.keys(datas).length) > 1 ? "s" : "") +
                  " filtré" +
                  ((maxResult ? maxResult : Object.keys(datas).length) ? "s" : "") +
                  ")"
                : ""
            }}
          </h1>
          <div>
            <button
              v-if="isFiltered"
              class="btn-icon me-1 btnReset"
              v-tooltip="{ title: $t('init_search') }"
              type="button"
              @click="resetSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-arrows-rotate" />
            </button>
            <button
              class="btn-icon btnOpen"
              v-tooltip="{ title: $t('search_motor') }"
              type="button"
              @click="openSearch"
            >
              <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
            </button>
          </div>
        </div>
        <div class="widget-content">
          <SortTableComponent
            :actions="listActions"
            :apiFilters="true"
            :columns="columns"
            :datas="datas"
            :idKey="6"
            :loading="loading"
            :maxResult="maxResult"
            :isSearchAvailable="true"
            :defaultLimit="10"
            :statusKey="4"
            type="registration-alert"
            ref="sortTable"
            @refresh="refresh"
            @openSearch="openSearch"
            @edit="edit"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-2">
      <ActionsBlock :actions="actions" @export="exportAlerts" />
    </div>
  </div>
  <ModalFormComponent
    :models="models"
    :title="modalTitle"
    :storageKey="sessionStorageKey"
    @search="search"
    @submit="submit"
  />
</template>

<script>
import { trainingManager } from "@/services/training/training-manager";
import ActionsBlock from "@/components/blocks/ActionsBlock.vue";
import SortTableComponent from "@/components/table/sortTable/SortTableComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { sortableTableManager } from "@/services/utilities/sortable-table-manager";
import { mapActions } from "pinia";
import { useMainStore } from "@/store/main/main";
import ModalFormComponent from "@/components/form/ModalFormComponent.vue";
import { registrationManager } from "@/services/registration/registration-manager";
import { i18n } from "@/i18n";
import { studeaManagerManager } from "@/services/studea-manager/studea-manager-manager";
import { notificationManager } from "@/services/utilities/notification-manager";
import { formValidator } from "@/services/form/form-validator";

export default {
  name: "RegistrationAlertListView",
  components: {
    ModalFormComponent,
    SortTableComponent,
    ActionsBlock,
  },
  data() {
    return {
      columns: [],
      models: [],
      modalTitle: "",
      loading: false,
      isFiltered: false,
      listParams: [],
      datas: [],
      isSearchOpen: false,
      sessionStorageKey: "registration-alert",
      maxResult: 0,
      triadListOpen: false,
      editId: null,
      trainingCourse: {},
      modalType: "edit",
      actions: [
        {
          actionType: "button",
          icon: "download",
          type: "primary",
          action: "export",
          translation: i18n.global.tc(
            "global.export.title",
            { name: i18n.global.tc("registration.alert.title", 2).toLowerCase() },
            1,
          ),
          cfaStyle: true,
        },
      ],
    };
  },
  computed: {
    listActions() {
      return [
        {
          actionType: "button",
          icon: registrationManager.setAlertActionIcon(),
          type: "primary",
          action: "edit",
          translation: registrationManager.setAlertActionTootltip(),
          cfaStyle: true,
        },
      ];
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.setParams();
      this.getDatas();
    },

    setParams() {
      if (!this.listParams || !Object.keys(this.listParams).length) {
        this.listParams = {
          search: "",
          sortByField: 0,
          sortOrder: "ASC",
          limit: 50,
          offset: 0,
        };
      }
    },

    search(params) {
      if (this.modalType === "search") {
        this.loading = true;
        this.$refs.sortTable.activePage = 1;
        this.listParams["offset"] = 0;
        this.listParams["search"] = params;
        this.getDatas();
        this.isFiltered = true;
      }
    },

    postEdit() {
      let params = formManager.processForm(this.models);
      registrationManager.put("registration-alert", params, this.editId).then((res) => {
        if (res && !res.hasError) {
          notificationManager.showNotification(
            "success",
            i18n.global.tc("global.edit.success", 2, {
              name: i18n.global.tc("registration.alert.title", 1).toLowerCase(),
            }),
          );
          this.models = [];
          this.init();
        } else if (res.responses && res.responses[0].validationErrors) {
          notificationManager.showNotification("error", this.$t("signed_error"));
          formValidator.processResponses(res.responses[0].validationErrors, this.models);
        }
      });
    },

    submit() {
      if (this.modalType === "edit") {
        this.postEdit();
      }
    },

    refresh(params) {
      this.listParams = params;
      this.init();
    },

    getFilters() {
      this.models = [];
      this.modalType = "search";
      this.modalTitle = this.$tc("global.search.title", 2, {
        name: this.$tc("registration.alert.title", 2).toLowerCase(),
      });
      trainingManager.form("registration-alert", null, true).then((data) => {
        this.models = data;
      });
    },

    openSearch() {
      this.getFilters();
      this.isSearchOpen = true;
    },

    resetSearch() {
      this.listParams = [];
      this.$refs.sortTable.activePage = 1;
      this.datas = [];
      this.columns = [];
      this.isFiltered = false;
      window.sessionStorage.removeItem(this.sessionStorageKey);
      this.init();
    },

    edit(row) {
      this.sessionStorageKey = null;
      this.modalTitle = i18n.global.tc("global.edit.title", 2, {
        name: i18n.global.tc("registration.alert.title", 2).toLowerCase(),
      });
      this.models = [];
      this.modalType = "edit";
      this.editId = row.id;
      trainingManager.form("registration-alert", this.editId).then((data) => {
        this.models = data;
      });
    },

    exportAlerts() {
      studeaManagerManager.export("registration-alert", null, {});
    },

    getDatas() {
      if (window.sessionStorage.getItem(this.sessionStorageKey)) {
        this.listParams["search"] = JSON.parse(window.sessionStorage.getItem(this.sessionStorageKey));
        this.isFiltered = true;
      }
      if (this.isFiltered) {
        this.listParams["search"] = formManager.getQuery(this.listParams["search"]);
      }
      registrationManager.list(this.listParams, "registration-alert", true).then((data) => {
        this.columns = sortableTableManager.getEntriesColumns(data.columns, this.columns);
        this.datas = data.data;
        this.maxResult = data.count;
        this.loading = false;
        this.setAppLoading(false);
      });
    },

    ...mapActions(useMainStore, { setAppLoading: "setAppLoading" }),
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__dot {
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin: auto;
  }

  &__col {
    display: flex;
    align-items: center;
  }

  &__head {
    padding: 0 1rem;
    color: var(--primary-color);
    font-weight: 700;
    margin-bottom: 10px;
  }

  &__link {
    font-weight: 500;
    text-decoration: underline;
    color: var(--primary-color);
    display: block;
  }
}
</style>
